import React, { useEffect, useRef, useState } from 'react'
import MovieLength from '../MoviesGeneral/MovieLength'
import OriginalTitle from './OriginalTitle'
import Genres from './Genres'
import CinemaStart from './CinemaStart'
import Actors from './Actors'
import ReactScrollLink from '../General/ReactScollLink';
import Director from './Directors'
import ProductionYear from './ProductionYear'
import ProductionCountry from './ProductionCountry'
import Fsk from '../MovieInformation/Fsk'
import Translation from '../General/Translation'
import seperateAttributes from '../functions/seperateAttributes'
import ItemAttributes from '../PosterFormatItem/ItemAttributes'
import AmbientPicture from '../MovieInformation/AmbientPicture'
import getImageUrl from '../functions/getImageUrl'
import Slider from 'react-slick'
import { SliderArrowNext, SliderArrowPrev } from '../SliderGeneral/SliderArrows'
import TrailerLarge from '../Trailer/TrailerLarge'
import getBrowserWidth from '../functions/getBrowserWidth'
import TrailerSmall from '../Trailer/TrailerSmall'
import FskWrapper from '../MovieInformation/FskWrapper'
import BackgroundImage from './BackgroundImage'

const MovieDetails = ({
        itemID, 
        theme, 
        moviesData, 
        translation, 
        backgroundImage, 
        attributeStyling, 
        detailsStyling, 
        scrollToPosition, 
        isMobile, 
        onCloseDetails,
        trailerImage
    }) => {
    if(!moviesData[itemID]) {
        return ''
    }

    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const [itemsToDisplay, setItemsToDisplay] = useState(1)

    let sliderRef1 = useRef(null);
    let sliderRef2 = useRef(null);

    useEffect(() => {
        setNav1(sliderRef1);
        setNav2(sliderRef2);
        updateDimensions()

        window.addEventListener("resize",  _.debounce(updateDimensions, 300))

        return () => {
            window.removeEventListener("resize",  _.debounce(updateDimensions, 300))
        }
    }, []);

        
    const getMovieItemLength = (width) => {
        if(width > 999) {
            return 5
        }
        if(width > 519) {
            return 3
        }
        else {
            return 2
        }
    }

    const updateDimensions = () => {
        const newItemsToDisplay = getMovieItemLength(getBrowserWidth())

        if(newItemsToDisplay !== itemsToDisplay) {
            setItemsToDisplay(newItemsToDisplay)
        }
    }

    const movieData = moviesData[itemID]
    const { title, description, length, origTitle, genres, startingDate, actors, directors, trailerURL, titleDisplay, productionYear, productionCountry, fsk, technologyAttributes, images } = movieData
    const { backgrounds } = images
    const containsOv = _.find(technologyAttributes, attribute => {
        return attribute.id === 'ovwefewfwef'
    })

    //backgrounds is shuffled so that the gallery does not have the same start image as the details background and the trailer image
    const randomizeBackgrounds = backgrounds ? _.shuffle(backgrounds) : null

    const {technologyAttributesWithIcons} = seperateAttributes(technologyAttributes)
    const noAttributesWithIconsToDisplay = ((technologyAttributesWithIcons.length === 1 && (technologyAttributesWithIcons[0].id === '2d' || technologyAttributesWithIcons[0].id === '1087')) || technologyAttributesWithIcons.length === 0) ? true : false
    const currentTitle = titleDisplay ? titleDisplay : containsOv && origTitle ? origTitle : title 

    return (
        <div className={'movie-details ' + theme.toLowerCase() + ' ' + detailsStyling}>
            <div className="close-button-wrapper">
                <ReactScrollLink 
                    to={scrollToPosition + ' movieInformation'}  
                    smooth={false} offset={-200} 
                    className="close-button cursor-pointer" 
                    onClick={() => onCloseDetails({movieTitle: currentTitle})
                } >
                    {isMobile ? (
                        <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                            <polygon className="cls-1" points="13.73 30 14.83 28.99 2.71 15.74 30 15.74 30 14.24 2.71 14.24 14.82 1.01 13.71 0 0 14.99 13.73 30"/>
                        </svg>
                    ) : (
                        <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                            <polygon className="cls-1" points="25 1.06 23.94 0 12.5 11.44 1.06 0 0 1.06 11.44 12.5 0 23.94 1.06 25 12.5 13.56 23.94 25 25 23.94 13.56 12.5 25 1.06"/>
                        </svg>
                    )}
                </ReactScrollLink>
            </div>

            {theme !== 'Arthouse' ? (detailsStyling === 'colored_blocks' && isMobile) ? (
                <div className='top-wrapper'>
                    <AmbientPicture isMobile={isMobile} image={backgroundImage}/>
                    {trailerURL && isMobile && <TrailerSmall    
                        trailerURL={trailerURL}
                        fsk={fsk}
                        translation={translation}/>}
                </div>
            ) : (
                <div className='top-wrapper'>
                    <AmbientPicture isMobile={isMobile} image={backgroundImage} parallax={true}/>
                    {trailerURL && isMobile && <TrailerSmall      
                        trailerURL={trailerURL}
                        fsk={fsk}
                        translation={translation}/>}
                </div>
            ) : ('')}

            <div className={'movie-details-container'}>
                <div className='movie-details-content'>
                    <div className='top-part-wrapper'>
                        {theme !== 'Arthouse' && <div className={'movie-text'}> 
                            <div className={'title title-xlarge-bold'}  style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: currentTitle}}></div>

                            {description && <div className={'description text-light'} style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: description}}></div>}

                            <div className={'information'}>
                                <div className='fsk-length-wrapper'>
                                    <FskWrapper fsk={fsk}/>
                                    <MovieLength length={length} translation={translation}/>
                                </div>
                                <OriginalTitle origTitle={origTitle} translation={translation}/>
                                <Genres genres={genres} translation={translation}/>
                                <ProductionYear productionYear={productionYear} translation={translation}/>
                                <ProductionCountry productionCountry={productionCountry} translation={translation}/>
                                <CinemaStart startingDate={startingDate} translation={translation}/>
                            </div>
                        </div>}
                        {theme === 'Arthouse' && <div className='arthouse-details-header-wrapper'>
                            <div className='top-wrapper'>
                                <AmbientPicture isMobile={isMobile} image={backgroundImage} parallax={true}/>
                                {trailerURL && !isMobile && <TrailerSmall    
                                    trailerURL={trailerURL}
                                    fsk={fsk}
                                    translation={translation}/>
                                }
                            </div>
                            <div className='information-flex-container'>
                                <div className={'movie-text'}> 
                                    <div className={'title title-xlarge-bold'}  style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: currentTitle}}></div>
                                    <div className={'information'}>
                                        <div className='row-flex-information'>
                                            {length && <MovieLength length={length} translation={translation}/>}
                                            <FskWrapper fsk={fsk}/>
                                            {!noAttributesWithIconsToDisplay && technologyAttributesWithIcons.length !== 0 && <div className='attributes-with-icons'>
                                                <ItemAttributes attributeStyling={attributeStyling} translation={translation} attributes={technologyAttributesWithIcons} canBeColored={true} />
                                            </div>}
                                        </div>
                                        <Genres genres={genres} translation={translation}/>
                                        <ProductionYear productionYear={productionYear} translation={translation}/>
                                        <OriginalTitle origTitle={origTitle} translation={translation}/>
                                        <ProductionCountry productionCountry={productionCountry} translation={translation}/>
                                    </div>
                                </div>
                                <div className={'description text-light'} style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: description}}></div>
                            </div>
                        </div>}
                        {theme !== 'Arthouse' && trailerURL && !isMobile && <TrailerLarge
                            trailerURL={trailerURL}
                            isMobile={isMobile}
                            theme={theme}
                            fsk={fsk}
                            backgroundImage={trailerImage}
                            translation={translation}
                        />}
                    </div>

                    {randomizeBackgrounds && randomizeBackgrounds.length > 1 && <div className='image-gallery'>
                        <Slider 
                            asNavFor={nav2} 
                            ref={slider => (sliderRef1 = slider)}
                            arrows={false}
                            fade={true}
                            className='main-slide'
                        > 
                            {randomizeBackgrounds.map((backgroundObj, index) => {
                                return <BackgroundImage
                                        image={backgroundObj}
                                        key={index}
                                    />
                            })}
                        </Slider> 
                        {randomizeBackgrounds.length <= itemsToDisplay ? (
                            <Slider   
                                asNavFor={nav1}
                                ref={slider => (sliderRef2 = slider)}
                                slidesToShow={randomizeBackgrounds.length}
                                swipeToSlide={false}
                                focusOnSelect={true}
                                className='small-slide no-slider'
                                arrows={false}
                                responsive={[
                                    { 
                                        "breakpoint": 519, 
                                        "settings": { 
                                            "slidesToShow": randomizeBackgrounds.length
                                        } 
                                    }, { 
                                        "breakpoint": 999, 
                                        "settings": { 
                                            "slidesToShow": randomizeBackgrounds.length
                                        } 
                                    }
                                ]}
                            > 
                                {randomizeBackgrounds.map((backgroundObj, index) => {
                                      return <BackgroundImage
                                            image={backgroundObj}
                                            key={index}
                                        />
                                })}
                        </Slider> 
                        ) : (
                            <Slider   
                                asNavFor={nav1}
                                ref={slider => (sliderRef2 = slider)}
                                slidesToShow={5}
                                swipeToSlide={true}
                                focusOnSelect={true}
                                className='small-slide'
                                nextArrow={<SliderArrowNext/>}
                                prevArrow={<SliderArrowPrev/>}
                                responsive={[
                                    { 
                                        "breakpoint": 519, 
                                        "settings": { 
                                            "slidesToShow": 2
                                        } 
                                    }, { 
                                        "breakpoint": 999, 
                                        "settings": { 
                                            "slidesToShow": 3
                                        } 
                                    }
                                ]}
                            > 
                                {randomizeBackgrounds.map((backgroundObj, index) => {
                                      return <BackgroundImage
                                            image={backgroundObj}
                                            key={index}
                                        />
                                })}
                            </Slider> 
                        )}
                    </div>}

                    {directors !== null && <Director directors={directors} translation={translation}/>}
                    <Actors actors={actors} translation={translation}/>

                    <ReactScrollLink to={scrollToPosition + ' movieInformation'} className={'close-details-wrapper'}  smooth={false} offset={-200}>
                        <button className="close-details button text-light cursor-pointer" onClick={() => onCloseDetails({movieTitle: currentTitle})}>
                            <Translation id="close" trans={translation}>Schließen</Translation>
                        </button>
                    </ReactScrollLink>
                </div>
            </div>
        </div>
    )
}

export default MovieDetails